import { useState } from "react";
import { Button, TextField, Dialog, DialogTitle, DialogContent, DialogActions, Grid } from "@mui/material";


//this is for manual bill creation;
export const CreateBill = ({ open, onClose, onSave }: any) => {
  const [bill, setBill] = useState({
    invoiceNo: `INV-${Date.now()}`,
    orderNo: "",
    customerName: "",
    totalAmount: 0,
    paidAmount: 0,
    dueAmount: 0,
    status: "due", // Default status
  });

  // Handle Input Change
  const handleChange = (e: any) => {
    const { name, value } = e.target;
    const updatedBill = { ...bill, [name]: value };
    
    // Auto-calculate Due Amount
    updatedBill.dueAmount = Number(updatedBill.totalAmount) - Number(updatedBill.paidAmount);
    
    // Auto-update status
    updatedBill.status = updatedBill.dueAmount === 0 ? "paid" : "due";

    setBill(updatedBill);
  };

  // Save New Bill
  const handleSave = () => {
    onSave(bill);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Create New Bill</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField label="Order No." name="orderNo" fullWidth onChange={handleChange} />
          </Grid>
          <Grid item xs={12}>
            <TextField label="Customer Name" name="customerName" fullWidth onChange={handleChange} />
          </Grid>
          <Grid item xs={6}>
            <TextField label="Total Amount (₹)" name="totalAmount" type="number" fullWidth onChange={handleChange} />
          </Grid>
          <Grid item xs={6}>
            <TextField label="Paid Amount (₹)" name="paidAmount" type="number" fullWidth onChange={handleChange} />
          </Grid>
          <Grid item xs={12}>
            <TextField label="Due Amount (₹)" name="dueAmount" fullWidth value={bill.dueAmount} disabled />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">Cancel</Button>
        <Button onClick={handleSave} color="primary" variant="contained">Save Bill</Button>
      </DialogActions>
    </Dialog>
  );
};
